export default "__VITE_PUBLIC_ASSET__7bec16d1__"